/* ============================================================================
FILE: gy-carrousel-presse.js
ROLE: Carrousel flottant presse — dynamique autonome, sans traduction de texte.
============================================================================ */
(function(){
  "use strict";
  if(window.__GY_CARROUSEL_PRESSE__)return;
  window.__GY_CARROUSEL_PRESSE__=true;
  function init(root){
    if(!root||root.dataset.goodyCarouselReady==='true')return;
    root.dataset.goodyCarouselReady='true';
    var track=root.querySelector('.goody-floating-carousel__track');
    var slides=[].slice.call(root.querySelectorAll('.goody-floating-carousel__slide'));
    var prev=root.querySelector('.goody-floating-carousel__nav--prev');
    var next=root.querySelector('.goody-floating-carousel__nav--next');
    var currentIndex=0,startX=null,timer=null;
    var speed=parseInt(root.dataset.autoplaySpeed,10)||3500;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!track||!slides.length)return;
    function visible(){if(window.innerWidth<=749)return 1;if(window.innerWidth<=989)return Math.min(2,slides.length);return Math.min(3,slides.length)}
    function step(){var w=slides[0].getBoundingClientRect().width;var cs=window.getComputedStyle(track);var gap=parseFloat(cs.columnGap||cs.gap||0);return w+gap}
    function max(){return Math.max(0,slides.length-visible())}
    function update(){var m=max();if(currentIndex>m)currentIndex=0;if(currentIndex<0)currentIndex=m;track.style.transform='translateX('+(-currentIndex*step())+'px)';if(prev)prev.style.opacity=m===0?'.35':'1';if(next)next.style.opacity=m===0?'.35':'1'}
    function goNext(){var m=max();currentIndex=currentIndex>=m?0:currentIndex+1;update()}
    function goPrev(){var m=max();currentIndex=currentIndex<=0?m:currentIndex-1;update()}
    function stop(){if(timer){clearInterval(timer);timer=null}}
    function start(){if(reduce||max()===0)return;stop();timer=setInterval(goNext,speed)}
    if(next)next.addEventListener('click',function(){goNext();start()});
    if(prev)prev.addEventListener('click',function(){goPrev();start()});
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',start);
    track.addEventListener('touchstart',function(e){startX=e.touches[0].clientX;stop()},{passive:true});
    track.addEventListener('touchend',function(e){if(startX===null)return;var dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>40){dx<0?goNext():goPrev()}startX=null;start()},{passive:true});
    window.addEventListener('resize',function(){update();start()});update();start();
  }
  function boot(){document.querySelectorAll('[data-goody-floating-carousel]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);document.addEventListener('shopify:block:select',boot);
})();
